/** Copied from web/src/core/utils/text.ts */

/**
 * Returns the string pluralized with the count prefixed
 */
export const pluralize = (count: number, noun: string, suffix = 's', separator = ' '): string =>
  `${count}${separator}${noun}${count !== 1 ? suffix : ''}`;
